<template>
  <div class="form-group">
    <div class="form-row">
      <div class="col">
        <label for="min">Min Scale Value</label>
        <input
          type="number"
          class="form-control"
          id="min"
          v-model="inputData.Min_Value"
          v-on:change="inputDataChange()"
          required
        />
      </div>
      <div class="col">
        <label for="max">Max Scale Value</label>
        <input
          type="number"
          class="form-control"
          id="max"
          v-model="inputData.Max_Value"
          v-on:change="inputDataChange()"
          required
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    InputData: Object
  },
  data() {
    return {
      inputData: {Min_Value: 0, Max_Value: 5}
    }
  },
  watch:{
    InputData: function(){
      if(this.InputData != null){
      this.inputData = this.InputData;
      this.inputDataChange();
      }
    }
  },
  mounted(){
    if(this.InputData != null){
      this.inputData = this.InputData;
    }
    this.inputDataChange();
  },
  methods: {
    inputDataChange(){
      this.$emit('input-data-change', this.inputData)
    }
  }
}
</script>